<script>
export default {
    data() {
        return {
            sortHover: false
        };
    },

    methods: {
        toggleSort() {
            this.sortHover = !this.sortHover;
        }
    }
};
</script>

<style lang="scss">
.filter {
    &:hover {
        > a,
        > button {
            @apply text-gray-700;

            &:hover {
                @apply text-white;
            }
        }
    }
}
</style>
